export { type CollectionMorpheme, collectionMorphemeTable } from "#collection-morpheme-table";
